import React, { memo } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { GroupItem } from './index.styled'

import Input from './input'

export const Group = ({ name, defaultValue = [], options, ...props }) => {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      render={({ field: { onChange, value } }) =>
        Object.keys(options).map((val, key) => (
          <GroupItem key={key}>
            <Input
              onChange={() => {
                const newValue = [...value]
                const index = newValue.indexOf(val)

                if (index > -1) {
                  newValue.splice(index, 1)
                } else {
                  newValue.push(val)
                }

                onChange(newValue)
              }}
              value={val}
              title={options[val]}
              checked={value.includes(val)}
              {...props}
            />
          </GroupItem>
        ))}
      name={name}
      defaultValue={defaultValue}
    />
  )
}

const CheckBoxInput = memo(({ name, defaultValue = '', ...props }) => {
  const { control } = useFormContext()
  return (
    <Controller
      control={control}
      render={({ field: { onChange, value } }) => (
        <Input {...props} onChange={onChange} checked={value} />
      )}
      name={name}
      defaultValue={defaultValue}
    />
  )
})

CheckBoxInput.displayName = 'CheckBoxInput'

export default CheckBoxInput
